import * as ACTION_TYPES from "../actions/action-types";
import { TEAM_SETTING_DEFAULT_EXPANDED } from "../components/TeamSetting/TeamSettingSidebar/teamSettingSidebar.constants";

const initialState = {
  showTeamSettingSidebar: false,
  expanded: TEAM_SETTING_DEFAULT_EXPANDED,
};

/**
 * Team settings slide-out (project information, configuration, stages, logs).
 */
const teamSettingSidebar = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.TOGGLE_TEAM_SETTING_SIDEBAR:
      return {
        ...state,
        showTeamSettingSidebar: payload.showTeamSettingSidebar,
        ...(payload.showTeamSettingSidebar ? {} : { expanded: TEAM_SETTING_DEFAULT_EXPANDED }),
      };
    case ACTION_TYPES.SET_TEAM_SETTING_SIDEBAR_EXPANDED:
      return {
        ...state,
        expanded: payload,
      };
    default:
      return state;
  }
};

export default teamSettingSidebar;
